import { Box } from '@mui/material';
import React from 'react';
import CompliancePanel from './Components/CompliancePanel';
import CurrentlyDisplayedCard from './Components/CurrentlyDisplayed/Components/CurrentlyDisplayedCard';
import HistoryPanel from './Components/HistoryPanel';
import PanelTabs from './Components/PanelTabs';
import DetectionGroupContextProvider from './Contexts/DetectionGroupContext/DetectionGroupContextProvider';
import StyledBox from './styles';

export default function SessionPanel() {
  const [tab, setTab] = React.useState({ index: 0, updatedAt: Date.now() });
  return (
    <DetectionGroupContextProvider tab={tab}>
      <StyledBox>
        <CurrentlyDisplayedCard />
        <PanelTabs
          index={tab.index}
          setIndex={(newValue: number) => { setTab({ index: newValue, updatedAt: Date.now() }); }}
          updatedAt={tab.updatedAt}
        />
        <Box className="content">
          {tab.index === 0 && <HistoryPanel />}
          {tab.index === 1 && <CompliancePanel />}
        </Box>
      </StyledBox>
    </DetectionGroupContextProvider>
  );
}
